import { axiosTokenInstance } from 'src/utils/axiosInstance.utils';
import { apiUrls } from 'src/utils/properties.utils';
import { ProductionMapping } from 'src/models/Management.interface';
import { SortOrder } from 'src/models/Sort.types';

export const getAllProductionMappings = async (
  offset: number,
  limit: number,
  search: string,
  sortBy: string,
  order: SortOrder
): Promise<{
  data: ProductionMapping[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
}> => {
  const response = await axiosTokenInstance.get(apiUrls.PRODUCTION_MAPPING, {
    params: {
      offset,
      limit,
      search,
      sortBy,
      order,
    },
    withCredentials: true,
  });
  return response.data;
};

export const getProductionMappingById = async (
  id: string
): Promise<ProductionMapping> => {
  const response = await axiosTokenInstance.get(
    `${apiUrls.PRODUCTION_MAPPING}/${id}`
  );
  return response.data;
};

export const addProductionMapping = async (payload: {
  productId: string;
  details: { rawMaterialId: string; quantity: number }[];
}): Promise<{ message: string }> => {
  const response = await axiosTokenInstance.post(
    apiUrls.PRODUCTION_MAPPING,
    payload
  );
  return response.data;
};

export const editProductionMapping = async (payload: {
  id: string;
  productId: string;
  details: { id?: string; rawMaterialId: string; quantity: number }[];
}): Promise<{ message: string }> => {
  const response = await axiosTokenInstance.patch(
    apiUrls.PRODUCTION_MAPPING,
    payload
  );
  return response.data;
};

export const deleteProductionMapping = async (
  id: string
): Promise<{ message: string }> => {
  const response = await axiosTokenInstance.delete(
    `${apiUrls.PRODUCTION_MAPPING}/${id}`
  );
  return response.data;
};
